import { theme } from '@zappyrent/hundop';

import {
  RadiobuttonContainer,
  Icon,
  StyledRadiobutton,
} from './Radiobutton.styles';

type IRadiobutton = {
  className?: string;
  checked?: boolean;
  labelText?: string;
  onClick?: () => void;
  user?: 'landlord' | 'tenant';
};

const Radiobutton = ({
  className,
  checked,
  labelText,
  user,
  onClick,
}: IRadiobutton) => {
  const handleOnClick = (
    event: React.MouseEvent<HTMLDivElement | HTMLLabelElement>,
  ) => {
    event.stopPropagation();
    onClick && onClick();
  };
  return (
    <RadiobuttonContainer className={className} onClick={handleOnClick}>
      <StyledRadiobutton checked={checked}>
        <Icon viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="12"
            r="8"
            fill={
              user === 'tenant'
                ? theme.colors.tenant.main
                : theme.colors.landlord.main
            }
          />
        </Icon>
      </StyledRadiobutton>
      <label onClick={handleOnClick}>{labelText}</label>
    </RadiobuttonContainer>
  );
};

export { Radiobutton };
